/**
 * Datos de navegación y configuración del sitio
 */

/**
 * Enlaces de navegación principal
 */
export const navLinks = [
  {
    id: 1,
    label: 'Inicio',
    url: '/',
  },
  {
    id: 2,
    label: 'Quiénes Somos',
    url: '/nosotros',
  },
  {
    id: 3,
    label: 'Productos',
    url: '/productos',
  },
  {
    id: 4,
    label: 'Recetas',
    url: '/recetas',
  },
  {
    id: 5,
    label: 'Noticias',
    url: '/noticias',
  },
  {
    id: 6,
    label: 'Portal de transparencia',
    url: '/transparencia',
  },
  {
    id: 7,
    label: 'Contacto',
    url: '/contacto',
  },
];

/**
 * Enlaces de redes sociales
 */
export const socialLinks = [
  {
    id: 1,
    name: 'Facebook',
    url: 'https://www.facebook.com/IntercasaCanarias',
    icon: 'facebook',
  },
  {
    id: 2,
    name: 'X',
    url: 'https://x.com/IntercasaCan',
    icon: 'x',
  },
  {
    id: 3,
    name: 'YouTube',
    url: 'https://www.youtube.com/user/IntercasaCanarias',
    icon: 'youtube',
  },
  {
    id: 4,
    name: 'Instagram',
    url: 'https://www.instagram.com/intercasacanarias/',
    icon: 'instagram',
  },
  {
    id: 5,
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/company/intercasa-s-a-',
    icon: 'linkedin',
  },
];

/**
 * Enlaces legales del footer
 */
export const legalLinks = [
  {
    id: 1,
    label: 'Subvenciones',
    url: '/transparencia/ayudas',
  },
  {
    id: 2,
    label: 'Aviso Legal',
    url: '/aviso',
  },
  {
    id: 3,
    label: 'Política de Cookies',
    url: '/cookies',
  },
  {
    id: 4,
    label: 'Política de Privacidad',
    url: '/privacidad',
  },
];

/**
 * Información de copyright
 */
export const copyrightText = 'Todos los derechos reservados. © Intercasa S.A. 2018';

/**
 * Enlace del sello "Elaborado en Canarias"
 */
export const elaboradoEnCanariasLink = {
  url: 'https://elaboradoencanarias.com/brands/intercasa/',
  imageUrl: '/images/footer/elaborado-en-canarias.webp',
  alt: 'Elaborado en Canarias',
};
